// @ts-strict-ignore
import type { StyledElementProps } from '@udecode/plate';

export const LinkComponent = ({ nodeProps }: StyledElementProps) => {
  return (
    <a
      href={nodeProps.href}
      target='_blank'
      rel='noopener noreferrer'
      className='text-emerald-900'
    >
      {nodeProps.href}
    </a>
  );
};
